export enum ReceiptExpensesPickingListTargetType {
    Customer = 1,
    Employee = 2,
    Partner = 3,
    PostOffice = 4
}